import { VidyoConnector } from "@/features/vidyo-call/types/vidyoclient-nativewebrtc-sdk";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export async function createChatLifecycle(vidyoConnector: VidyoConnector) {
  const addMessage = useVidyoStore.getState().chat.addMessage;

  await Promise.all([
    vidyoConnector.RegisterMessageEventListener({
      onChatMessageReceived: (participant, message) => {
        addMessage({
          participantId: participant.userId,
          participantName: participant.name,
          message: message.body,
          timestamp: new Date(message.timestamp),
        });
      },
    }),
  ]);
}
